import { createContext, useContext, useMemo, useCallback } from 'react';

import useExpandedRegistery from '../hooks/useExpandedRegistery';

const LiveFeedContext = createContext();

export const LiveFeedProvider = ({
  children,
  config = {},
  amplitudeConfig = {},
  initialExpandedReadMore = [],
  initialExpandedComments = [],
}) => {
  // To remove with `flag-ujb-lf-pagination` cleanup
  const {
    toggle: toggleItemReadMore,
    isItemExpanded: isItemReadMoreExpanded,
    resetAll: resetReadMoreExpanded,
  } = useExpandedRegistery(initialExpandedReadMore);

  // To remove with `flag-ujb-lf-pagination` cleanup
  const {
    toggle: toggleItemComments,
    isItemExpanded: isItemCommentsExpanded,
    resetAll: resetCommentsExpanded,
  } = useExpandedRegistery(initialExpandedComments);

  // To remove with `flag-ujb-lf-pagination` cleanup
  const resetExpandedRegisteries = useCallback(() => {
    resetReadMoreExpanded();
    resetCommentsExpanded();
  }, [resetReadMoreExpanded, resetCommentsExpanded]);

  const value = useMemo(
    () => ({
      config,
      amplitudeConfig,
      toggleItemReadMore,
      isItemReadMoreExpanded,
      toggleItemComments,
      isItemCommentsExpanded,
      resetExpandedRegisteries,
    }),
    [
      config,
      amplitudeConfig,
      toggleItemReadMore,
      isItemReadMoreExpanded,
      toggleItemComments,
      isItemCommentsExpanded,
      resetExpandedRegisteries,
    ],
  );

  return (
    <LiveFeedContext.Provider value={value}>
      {children}
    </LiveFeedContext.Provider>
  );
};

export const useLiveFeedContext = () => useContext(LiveFeedContext);

export const withLiveFeedContext = (Component) => (props) => {
  const contextValue = useLiveFeedContext();

  return <Component {...contextValue} {...props} />;
};

export default LiveFeedContext;
